<template>
<div class="pageContent" align="center" style="position:absolute;">
    <!-- 头部 Logo和首页图片 -->

    <mu-appbar style="height: 0.8rem;color:black;background-color:#FFFFFF;box-shadow: 1px 4px 90' 20%;position: fixed;top: 0%; max-width: 7.5rem;">
      <!--返回上一层-->
      <img src="../../../static/Brand/Main/logoNEW_1.png" style="width:40%;float:left;margin-top: 0.3rem;margin-bottom:0.1rem;" />
      <a href='tel:4006-998-998'>  <img src="../../../static/Brand/Main/telephone.png" style="width:48%;float:right;margin-top: 0.8rem;margin-right:0.0rem" />  </a>
 
     </mu-appbar>

 
   <div style="position: relative; margin-top: 1rem;">
      <img src="../../../static/Brand/Main/top2_1.jpg" style="width:100%" />
   </div>
    
    <!-- 顶部留言部分 -->
   <div style="color:#FFFFFF;margin-bottom:0.5rem;">
          <!-- <div class="title1">诚邀加盟 加盟热线电话4006-998-998转6</div> -->
          <div class="title1">格林酒店 诚邀加盟</div>
          <div class="title2" style="color:#363636 ">加盟热线4006-998-988转6</div>
          <div style="margin-top: 0.2rem">
               <div style=" height: 0.75rem ; border-radius: 0.06rem;  border: 1px solid #e2e2e2; text-align:left;width:90% ;margin-top: 0.13rem  ">
                   <input v-model="Name" style=" margin-top: 0.13rem;border:0 ; outline:0 ; color:#a6a4a4 ;width: 90% ; margin-left: 0.2rem  " placeholder="姓名*" />
                </div>

                <div style=" height: 0.75rem ; border-radius: 0.06rem;  border: 1px solid #e2e2e2; text-align:left;width:90% ;margin-top: 0.13rem  ">
                   <input v-model="UserPhone" style="margin-top: 0.13rem; border:0 ; outline:0 ; color:#a6a4a4 ;width: 90% ; margin-left: 0.2rem  " placeholder="电话*" />
                </div>
                <div>
                  <input v-on:click="message"  type="button"   style="letter-spacing:0.1rem;width:90%; height:0.8rem; background-color:#36c27b; border-radius:4px;border-width:0;font-size:18px;color: #f5f5f5 ;margin-top: 0.13rem  "  value="立即留言" /> 
                </div>
          </div>
   </div>

     <!--线条-->
    <hr style="border:none; border-top:1px solid #F1F1F1;"></hr>
    <!-- 集团介绍 -->
    <div>
         <div class="title">集团简介</div>
            <div style="font-size:0.29rem;margin-left:0.2rem;margin-right:0.2rem;text-align:left;text-align:justify; 
  text-justify:inter-ideograph;">格林酒店集团（原格林豪泰酒店管理集团）2018年3月登陆纽交所（NYSE:GHG），是中国领先的酒店管理集团公司。</div>
                   
            <div style="font-size:0.29rem;margin-left:0.2rem;margin-right:0.2rem;text-align:left;margin-top: 0.3rem;text-align:justify; 
  text-justify:inter-ideograph;">2004年创立至今，格林酒店集团在中国340多个城市拥有5000多家酒店（含筹建），超过30万间客房，酒店规模位居全球和中国前列。通过始终如一的服务质量、标志性的酒店设计和广泛的地理布局，集团打造了格林东方、格美、格雅、格菲、无眠、格林豪泰、格盟、格林公寓、青皮树、贝壳、雅阁、澳斯特、都市花园、都市118精选、青年·都市迷你等优质品牌，覆盖高端、中高端、中端以及经济型酒店市场，为合作伙伴和客人提供多元化选择。</div>

            <div style="font-size:0.29rem;margin-left:0.2rem;margin-right:0.2rem;text-align:left;margin-top: 0.3rem;text-align:justify; 
  text-justify:inter-ideograph;">依托母公司格美集团（KOSMOS GROUP）在餐饮、数据智造领域的多元布局，格林酒店集团不仅为客人提供全方位的住宿和餐饮服务，还为合作伙伴打造了多元化的投资平台。</div>
    </div>

   <!--线条-->
    <hr style="border:none; border-top:1px solid #F1F1F1;"></hr>
    <!-- 加盟优势 -->
    <!--<div style=" width:90% ; margin:auto ">
         <div style="color:#363636;font-size:0.4rem;margin-top: 0.5rem;font-weight:bold;margin-bottom:0.2rem;">加盟优势</div>
         <div style="margin:auto ">
            <img v-bind:src="item" class="img-responsive" v-for="item in AllImg">
        </div>
    </div>-->
    <div class='advantage'>
      <div class="title">加盟优势</div>
        <div style="margin-left:3.5%;margin-right:3.5%;width:100%">
             <div v-if="ShowText1=='11'"  class="advantageitem" style="float:left" v-on:click="clickIcon(12)">
                <img src='../../../static/Brand/Main/1.png' style=" " />
             </div>
             <div  v-if="ShowText1=='12'"  class="advantageitem" style="float:left ;" v-on:click="clickIcon(11)">
               <div class="shade">
                <div class="shadetext"><div class="shadediv">综合成本仅为同类品牌的<span style="color:#E95341;font-size:0.25rem">一半</span></div></div>
               </div>
                <img src='../../../static/Brand/Main/1.png' style="  "/>   
             </div>
             <div v-if="ShowText2=='21'" class="advantageitem" style="float:left;margin-left:1.5%" v-on:click="clickIcon(22)">
                <img src='../../../static/Brand/Main/2.png' style=" "/>   
             </div>
             <div  v-if="ShowText2=='22'"  class="advantageitem" style="float:left;margin-left:1.5%" v-on:click="clickIcon(21)">
               <div class="shade">
                <div class="shadetext">
                    <!-- <div class="shadediv"><span style="color:#E95341;font-size:0.25rem">90%</span>以上的酒店在3.5年内回收成本<br>优异酒店投资回报率接近<span style="color:#E95341;font-size:0.25rem">100%</span></div></div> -->
                    <div class="shadediv">优异酒店投资回报率接近<span style="color:#E95341;font-size:0.25rem">100%</span></div></div>
               </div>
                <img src='../../../static/Brand/Main/2.png' style="  "/>   
             </div>
             <div v-if="ShowText3=='31'" class="advantageitem" style="float:left;margin-left:1.5%" v-on:click="clickIcon(32)">
                <img src='../../../static/Brand/Main/3.png' style=" "/>   
             </div>    
             <div  v-if="ShowText3=='32'"  class="advantageitem" style="float:left;margin-left:1.5%" v-on:click="clickIcon(31)">
               <div class="shade">
                <div class="shadetext">
                  <div class="shadediv">
                    <!-- <span style="color:#E95341;font-size:0.25rem">97%</span>自有客源<br> -->
                    <span style="color:#E95341;font-size:0.25rem">160</span>万高质量企业客户<br>
                    <span style="color:#E95341;font-size:0.25rem">5000</span>万会员及商旅客户推荐
                  </div>
                </div>
               </div>
                <img src='../../../static/Brand/Main/3.png' style="  "/>   
             </div>          
            <div v-if="ShowText4=='41'" class="advantageitem" style="float:left" v-on:click="clickIcon(42)">
              <img src='../../../static/Brand/Main/4.png' style=" "/>   
            </div>
            <div  v-if="ShowText4=='42'"  class="advantageitem" style="float:left ;" v-on:click="clickIcon(41)">
               <div class="shade">
                <div class="shadetext"><div class="shadediv">官网:www.<span style="color:#E95341;font-size:0.25rem">998</span>.com<br>电话:4006-<span style="color:#E95341;font-size:0.25rem">998</span>-<span style="color:#E95341;font-size:0.25rem">998</span><br>微信/手机APP搜索[<span style="color:#E95341;font-size:0.25rem">格林</span>]</div></div>
               </div>
                <img src='../../../static/Brand/Main/4.png' style="  "/>   
             </div> 
            <div v-if="ShowText5=='51'" class="advantageitem" style="float:left;margin-left:1.5%" v-on:click="clickIcon(52)">
              <img src='../../../static/Brand/Main/5.png' style=" "/>   
            </div>
            <div  v-if="ShowText5=='52'"  class="advantageitem" style="float:left;margin-left:1.5%" v-on:click="clickIcon(51)">
               <div class="shade">
                <div class="shadetext"><div class="shadediv">融合地方特色建筑风格与文化特色，酒店外观经久不衰，客房布置现代实用，设计匠心独运</div></div>
               </div>
                <img src='../../../static/Brand/Main/5.png' style="  "/>   
             </div> 
            <div v-if="ShowText6=='61'" class="advantageitem" style="float:left;margin-left:1.5%" v-on:click="clickIcon(62)">
              <img src='../../../static/Brand/Main/6.png' style=" "/>   
            </div> 
            <div  v-if="ShowText6=='62'"  class="advantageitem" style="float:left;margin-left:1.5%" v-on:click="clickIcon(61)">
               <div class="shade">
                <div class="shadetext"><div class="shadediv">集团自主PMS系统连接订房、购物
                </div></div>
               </div>
                <img src='../../../static/Brand/Main/6.png' style="  "/>   
             </div>           
            <div v-if="ShowText7=='71'" class="advantageitem" style="float:left" v-on:click="clickIcon(72)">
              <img src='../../../static/Brand/Main/7.png' style=" "/>   
            </div>
            <div  v-if="ShowText7=='72'"  class="advantageitem" style="float:left" v-on:click="clickIcon(71)">
               <div class="shade">
                <div class="shadetext"><div class="shadediv">定制管理学院，成熟的连锁管理模式和经验的管理团队
                </div></div>
               </div>
                <img src='../../../static/Brand/Main/7.png' style="  "/>   
             </div>  
            <div v-if="ShowText8=='81'" class="advantageitem" style="float:left;margin-left:1.5%" v-on:click="clickIcon(82)">
              <img src='../../../static/Brand/Main/8.png' style=" "/>   
            </div>
            <div  v-if="ShowText8=='82'"  class="advantageitem" style="float:left;margin-left:1.5%" v-on:click="clickIcon(81)">
               <div class="shade">
                <div class="shadetext"><div class="shadediv">聚集各行业精英及国际酒店管理经验为您保驾护航</div></div>
               </div>
                <img src='../../../static/Brand/Main/8.png' style="  "/>   
             </div> 
            <div v-if="ShowText9=='91'" class="advantageitem" style="float:left;margin-left:1.5%" v-on:click="clickIcon(92)">
              <img src='../../../static/Brand/Main/9.png' style=" "/>   
            </div>   
            <div  v-if="ShowText9=='92'"  class="advantageitem" style="float:left;margin-left:1.5%" v-on:click="clickIcon(91)">
               <div class="shade">
                <div class="shadetext"><div class="shadediv">联合银行等金融机构对特定的投资人给予融资扶持</div></div>
               </div>
                <img src='../../../static/Brand/Main/9.png' style="  "/>   
             </div>    
        </div>
      </div>
   <div style="clear: both"></div>
   <!--线条-->
   <div style="margin-top:0.5rem"></div>
    <hr style="border:none; border-top:1px solid #F1F1F1"></hr>
    <!-- 酒店品牌介绍 -->
    <div style="margin-bottom:0px;">
          <div style="color:#363636;font-size:0.4rem;margin-top: 0.5rem;font-weight:bold;margin-bottom:0.5rem;border-bottom:2px solid #36C27B;width:2.4rem">酒店品牌介绍</div>
          <div class="slider">
            <swiper :options="swiperOption">
              <swiper-slide v-for="item in brands2">
                <img :src="item.url" v-on:click="BrandGoto(item.pathstr)">
              </swiper-slide>
           </swiper>
          </div>
          <div style="font-size:0.2rem;text-align:left;" >※左右划动了解酒店品牌加盟详情</div>
    </div>
    
    <!--线条-->
    <hr style="border:none; border-top:1px solid #F1F1F1;margin-top:0.5rem"></hr>
    <!-- 留言部分 -->
    <div style="color:#FFFFFF;margin-bottom:1.5rem;" id="bottomMessage">
          <!-- <div class="title1">诚邀加盟 加盟热线电话4006-998-998转6</div> -->
          <div class="title1">格林酒店 诚邀加盟</div>
          <div class="title2" style="color:#363636 ">加盟热线4006-998-988转6</div>
          <!-- <div class="title">立即留言</div> -->
          <div style="margin-top: 0.2rem">
               <div style=" height: 0.75rem ; border-radius: 0.06rem;  border: 1px solid #e2e2e2; text-align:left;width:90% ;margin-top: 0.13rem  ">
                   <input v-model="name" style=" margin-top: 0.13rem;border:0 ; outline:0 ; color:#A6A4A4 ;width: 90% ; margin-left: 0.2rem  " placeholder="姓名*" />
                </div>

                <div style=" height: 0.75rem ; border-radius: 0.06rem;  border: 1px solid #e2e2e2; text-align:left;width:90% ;margin-top: 0.13rem  ">
                   <input v-model="contact" style="margin-top: 0.13rem; border:0 ; outline:0 ; color:#A6A4A4 ;width: 90% ; margin-left: 0.2rem  " placeholder="电话*" />
                </div>
                  
                <div style=" height: 0.75rem ; border-radius: 0.06rem;  border: 1px solid #e2e2e2; text-align:left;width:90% ;margin-top: 0.13rem  ">
                   <input v-model="address" style="margin-top: 0.13rem; border:0 ; outline:0 ; color:#A6A4A4 ;width: 90% ; margin-left: 0.2rem  " placeholder="城市" />
                </div>

                <div style=" height: 0.75rem ; border-radius: 0.06rem;  border: 1px solid #e2e2e2; text-align:left;width:90% ;margin-top: 0.13rem  ">
                   <input v-model="msg" style="margin-top: 0.13rem; border:0 ; outline:0 ; color:#A6A4A4 ;width: 90% ; margin-left: 0.2rem  " placeholder="留言" />
                </div>
                <div>
                  <input v-on:click="post" type="button"   style="letter-spacing:0.1rem;width:90%; height:0.8rem; background-color:#36c27b; border-radius:4px;border-width:0;font-size:18px;color: #f5f5f5 ;margin-top: 0.13rem  "  value="提交留言" /> 
                </div>
          </div>
          <div class="buttonText" style="font-size:0.28rem;color:#999999;">格林豪泰酒店（中国）有限公司版权所有</div>
          <div class="buttonText" style="font-size:0.1rem;color:#999999;">投资有风险，选择需谨慎</div>
    </div>


    <!-- 固定底部 -->
    <div  class="mu-bottom-nav mu-bottom-nav-shift" tabindex="0" style=" position: fixed;bottom: 0%;user-select: none; cursor: pointer; -webkit-appearance: none;-webkit-box-shadow: #000000 1px 4px 6px;
   -moz-box-shadow: #000000 1px 4px 6px;
   box-shadow: #000000 1px 4px 6px;
   background: #FFFFFF;z-index:9999;">
        <div style="float:left;font-size:0.3rem;color:#4B4B4B;;margin-right:1rem">
          <a href='tel:4006-998-998'>  <img src="../../../static/Brand/Main/tel.png" style="width:20%;" />
           <div  style="width:80%;float:right;color:#363636" > 电话咨询  </div></a>
        </div>
        <div style="float:right;font-size:0.3rem;color:#4B4B4B">
            <a href="#bottomMessage"><img src="../../../static/Brand/Main/message.png" style="width:20%" />
             <div  style="width:80%;float:right;color:#363636" >  在线留言   </div></a>
        </div>
    </div>
  <mu-toast id="alertline" v-if="toast" v-bind:message="hintMsg" @close="hideToast"/>
</div>
</template>



<script>
import api from "../../api";
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";
import loadListTail from "../../components/loadListTail";
import Scroll from "../../utils/loading";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import date from "../../utils/dateextend.js";
export default {
  data() {
    return {
      UserPhone: '',
      Name: '',
      AllImg: [],
      ShowText1:'11',
      ShowText2:'21',
      ShowText3:'31',
      ShowText4:'41',
      ShowText5:'51',
      ShowText6:'61',
      ShowText7:'71',
      ShowText8:'81',
      ShowText9:'91',
      swiperOption: {
        pagination: ".swiper-pagination",
        paginationClickable: true,
        autoplay: 2000,
        initialSlide: 0,
        autoplayDisableOnInteraction: false,
      },
      banners: [],
      brands2: [],
      brands: [
        {
          url: "../../../static/Brand/Main/banner_1.png",
          pathstr: "/BrandDetails/EastDetail",
        },
        {
          url: "../../../static/Brand/Main/banner_2.png",
          pathstr: "/BrandDetails/GemeiDetail",
        },
        {
          url: "../../../static/Brand/Main/banner_3.png",
          pathstr: "/BrandDetails/GeyaDetail",
        },
        {
          url: "../../../static/Brand/Main/banner_4.png",
          pathstr: "/BrandDetails/GefeiDetail",
        },

        {
          url: "../../../static/Brand/Main/banner_5.png",
          pathstr: "/BrandDetails/ShellDetail",
        },
        {
          url: "../../../static/Brand/Main/banner_6.png",
          pathstr: "/BrandDetails/GmengDetail",
        },
        {
          url: "../../../static/Brand/Main/banner_7.png",
          pathstr: "/BrandDetails/GreenTreeDetail",
        },
        {
          url: "../../../static/Brand/Main/banner_8.png",
          pathstr: "/BrandDetails/BeikeDetail",
        }
      ],
      toast: false,
      name:'',
      contact:'',
      address:'',
      area:'',
      msg:'',
      hintMsg:'',
      validCode:'',
    };
  },
  components: {
    swiper,
    swiperSlide
  },
  activated() {
    //this.GetAllImg();
    //this.GetActivityYekCMS();  
    window.location.href ="https://h5app.greentree.cn/h5Page/joinGT/index.html#/?sourcecode="+this.$route.query.sourcecode;

    if (this.banners.length == 0) {
      this.get();
    }
  },
  methods: {
    //...mapMutations(["setG_currentOrder"]), 
    BrandGoto(pathstr) {
        this.$router.push({ path:pathstr+"?sourcecode="+this.$route.query.source});      
    },
    // 九个图标初始化
    // GetAllImg() {
    //   this.AllImg = [];
    //   for (let i = 1; i < 10; i++) {
    //     this.AllImg = this.AllImg.concat('/static/Brand/Main/' + i + '.png');
    //   }
    // },
    get() {
      this.$http.post(api.getBanners()).then(res => {
        if (res.Result) this.banners = res.Data;
        this.brands2 = this.brands;
      });
    },
    // 后退一页
    goback() {
      javascript: history.go(-1);
    },
    showToast () {
      this.toast = true
      if (this.toastTimer) clearTimeout(this.toastTimer)
      this.toastTimer = setTimeout(() => { this.toast = false }, 2000)
    },
    hideToast () {
      this.toast = false
      if (this.toastTimer) clearTimeout(this.toastTimer)
    },
    clickIcon(value){
      if(value==11||value==12){
        this.ShowText1=value;   
      }       
      if(value==21||value==22){
        this.ShowText2=value;   
      }
      if(value==31||value==32){
        this.ShowText3=value;   
      }
      if(value==41||value==42){
        this.ShowText4=value;   
      }
      if(value==51||value==52){
        this.ShowText5=value;   
      }
      if(value==61||value==62){
        this.ShowText6=value;   
      }
      if(value==71||value==72){
        this.ShowText7=value;   
      }
      if(value==81||value==82){
        this.ShowText8=value;   
      }
      if(value==91||value==92){
        this.ShowText9=value;   
      }
    },
    validTop(){
      this.hintMsg = ''
      if(!this.Name.isLegal() || !this.UserPhone.isLegal()){
        this.hintMsg = '请勿使用非法字符！'
      }
      if(this.Name.trim() == ''){
        this.hintMsg = '请填写您的大名！'
      }
      else if(!this.Name.shorterThan(50)){
        this.hintMsg = '名字过长！'
      }
      if(this.UserPhone.trim() == ''){
        this.hintMsg = '请填写您的手机号码！'
      }
      else if(!this.UserPhone.shorterThan(50)){
        this.hintMsg = '联系方式过长！'
      }
      else if(!this.UserPhone.isPhone()){
        this.hintMsg = '请输入正确的手机号码！'
      }
      if(this.hintMsg == ''){
        return true
      }
      else{
        return false
      }  
    },
    valid(){
      this.hintMsg = ''
      if(!this.name.isLegal() || !this.contact.isLegal() || !this.address.isLegal() ||!this.msg.isLegal()){
        this.hintMsg = '请勿使用非法字符！'
      }
      if(this.name.trim() == ''){
        this.hintMsg = '请填写您的大名！'
      }
      else if(!this.name.shorterThan(50)){
        this.hintMsg = '名字过长！'
      }
      if(this.contact.trim() == ''){
        this.hintMsg = '请填写您的手机号码！'
      }
      else if(!this.contact.shorterThan(50)){
        this.hintMsg = '联系方式过长！'
      }
      else if(!this.contact.isPhone()){
        this.hintMsg = '请输入正确的手机号码！'
      }
      if(this.address.trim() != '' && !this.address.shorterThan(20)){
        this.hintMsg = '城市名称过长'
      }
      if(this.msg.trim() != '' && !this.msg.shorterThan(100)){
        this.hintMsg = '请确认留言内容不超过100个字符！'
      }
      if(this.hintMsg == ''){
        return true
      }
      else{
        return false
      }  
    },
    post (){
      if(!this.valid()){
        this.showToast()
        return
      }
      var params = new this.URLSearchParam();
      params.append('FranchiseeName', this.name);
      params.append('Contact', this.contact);
      params.append('HotelAdderssCity', this.address);
      params.append('ConstructionArea', this.area);
      params.append('LeaveMessage', this.msg);
      params.append('ValidCode', this.validCode);
      this.$http.post(api.JoinGreenMessage(), params.toParam()).then((res) => {
        console.log(res)
        if(res.Result == true){
          this.hintMsg = '您的留言已经提交！'
        }
        else{
          this.hintMsg = res.Message
        }
        this.showToast()
      });
    },
    message (){
      if(!this.validTop()){
        this.showToast()
        return
      }
      var params = new this.URLSearchParam();
      params.append('FranchiseeName', this.Name);
      params.append('Contact', this.UserPhone);
      params.append('HotelAdderssCity', '');
      params.append('ConstructionArea', this.area);
      params.append('LeaveMessage', '');
      params.append('ValidCode', this.validCode);
      this.$http.post(api.JoinGreenMessage(), params.toParam()).then((res) => {
        console.log(res)
        if(res.Result == true){
          this.hintMsg = '您的留言已经提交！'
        }
        else{
          this.hintMsg = res.Message
        }
        this.showToast()
      });
    },
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/theme.less";
// PAGE2  抽奖  图片
.img-responsive {
  width: 32%;
  margin:0 2px;
}
.advantage{
  width:100%;
  margin:auto;
      .advantageitem{      
        width:30%;            
      }
      .advantageitem img{
        width:100%;     
      }
}
.title{
  color:#363636;
  font-size:0.4rem;
  margin-top: 0.5rem;
  font-weight:bold;
  margin-bottom:0.5rem;
  border-bottom:2px solid #36C27B;
  width:1.6rem;
}
.buttonText
{
  margin-top: 0.2rem;
  margin-bottom:0.1rem;
  width:100%;
}
.slider {
  max-width: 7.5rem;
  width: 100%;
  background-color: #FFFFFF;
  img {
    max-width: 7.5rem;
    width: 100%;
  }
}
.brands {
  h3 {
    margin-top: 0.2rem;
    height: 1rem;
    color: #333333;
    font-size: 0.34rem;
    margin: 0;
    line-height: 1rem;
    padding-left: 0.5em;
  }
}
.swiper-pagination {
  .swiper-pagination-bullet-active {
    background: @primaryColor;
  }
}
      .bottomstyle {
    position: fixed;
    top: 20%;
    width: 100%;
    z-index: 1002;
    left: 10%;
    }

.mu-bottom-nav-shift {
      background-color: #FFF;
      .mu-buttom-item-wrapper {
        .bottomIconColor {
          color: @primaryColor;
        }
        .mu-bottom-item-text {
          color: @primaryColor;
        }
      }
    }
.shade{
  background-color:#20140B;
  opacity:0.85;
  width:2.25rem;
  height:2.25rem;
  position:absolute; 
}
.shadetext{
  margin:0.1rem auto;
  text-align:left;
  font-family:Ping Fang SC;
  font-size:0.2rem;
  opacity:2;
  color:#FFFFFF;
  width:2.05rem;
  height:2.05rem;
  table-layout:fixed; 
  word-break:break-all; 
  overflow:hidden;
  text-align:justify; 
  text-justify:inter-ideograph;
}
.shadediv{
  vertical-align:middle;
  display:table-cell;
  width:2.05rem;
  height:2.05rem
}
</style>




// WEBPACK FOOTER //
// BrandIndex.vue?ee183474